module.exports = __webpack_public_path__ + "static/media/27.d93ba583.jpg";